import './trending-category-card.scss'

import React from 'react'

import Card from '@/components/card/card'

const config = {
  className: 'trending-category-card',
  minicard: true,
  hasNoImage: true,
  hasUnderline: false,
  hasNoLocationDisplay: true,
  isSearch: false,
  isCarousel: false,
}

export const TrendingCategoryCard = ({ item, ...restProps }) => (
  <Card item={item} {...config} {...restProps} />
)
